export enum MediaProcessingStatus {
  Created = 'CREATED',
  Processing = 'PROCESSING',
  Accepted = 'ACCEPTED',
  Rejected = 'REJECTED',
  Trained = 'TRAINED',
  Verified = 'VERIFIED',
}
